var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
export function getSessionSearch(key) {
    var searchHistory = sessionStorage.getItem(key);
    if (searchHistory !== null) {
        return searchHistory.split(',');
    }
    return undefined;
}
export function setSessionSearch(key, queryHistory) {
    if (queryHistory === void 0) { queryHistory = []; }
    if (queryHistory.length > 0) {
        sessionStorage.setItem(key, queryHistory.join(','));
    }
}
/**
 * Strips the category search matches from the query,
 * returning only the query to be applied to the defaultField
 */
export function getGlobalQuery(categories, query) {
    if (categories.length < 1)
        return query;
    return categories
        .reduce(function (q, match) {
        return q.replace(match, '');
    }, query)
        .trim();
}
/**
 * Returns new array of supplied array, limited to most recent three items
 */
export function lastThree(hist) {
    return __spreadArray([], hist).reverse().slice(0, 3).reverse();
}
//# sourceMappingURL=utils.js.map